export const NO_TRANSACTION = 'NO_TRANSACTION ';
export const WAITING = 'WAITING ';
export const SUCCESSFUL = 'SUCCESSFUL';
export const FAILED = 'FAILED';
